export var OperationalJurisdictionEnum;
(function (OperationalJurisdictionEnum) {
    OperationalJurisdictionEnum["GE"] = "GE";
    OperationalJurisdictionEnum["UA"] = "UA";
    OperationalJurisdictionEnum["EU"] = "EU";
    OperationalJurisdictionEnum["OTC"] = "OTC";
})(OperationalJurisdictionEnum || (OperationalJurisdictionEnum = {}));
//# sourceMappingURL=operational-jurisdiction.enum.js.map